import { render, staticRenderFns } from "./deviceDetail.vue?vue&type=template&id=5dd14c79&scoped=true"
import script from "./deviceDetail.vue?vue&type=script&lang=js"
export * from "./deviceDetail.vue?vue&type=script&lang=js"
import style0 from "./deviceDetail.vue?vue&type=style&index=0&id=5dd14c79&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd14c79",
  null
  
)

export default component.exports